<template>
    <v-list-group
        no-action
        :value="item.title + '-' + level"
    >
        <template v-slot:activator="{ props, isOpen }">
            <v-list-item
                v-bind="props"
                rounded
                class="mb-1"
                color="info"
                @click="handleGroupClick"
            >
                <!-- Icon -->
                <template v-slot:prepend>
                    <v-icon v-if="item.icon" class="iconClass">
                        {{ item.icon }}
                    </v-icon>
                </template>

                <!-- Title (when not mini) -->
                <v-list-item-title v-if="!mini">
                    {{ item.title }}
                </v-list-item-title>
                <template v-slot:append>
                    <div class="d-flex align-center">
                        <ReservationBadge :count="item.badge" :show="!mini" />
                        <v-icon v-if="!mini" size="small">{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
                    </div>
                </template>
            </v-list-item>
        </template>

        <!-- Render children -->
        <template
            v-for="subitem in item.children"
            :key="subitem.id || subitem.title"
        >
            <NavCollapse
                v-if="subitem.children"
                :item="subitem"
                :level="level + 1"
                :mini="mini"
                style="margin-left: -15px"
            />
            <NavItem
                v-else
                :item="subitem"
                :level="level + 1"
                :mini="mini"
            />
        </template>
    </v-list-group>
</template>

<script>
import NavItem from "../navItem/NavItem.vue";
import ReservationBadge from "@/components/ReservationBadge.vue";
import { useRouter } from "vue-router";

export default {
    props: {
        item: { type: Object, required: true },
        level: { type: Number, required: true },
        mini: { type: Boolean, required: true },
    },
    components: {
        NavItem,
        ReservationBadge,
    },
    setup(props) {
        const router = useRouter();

        const handleGroupClick = (e) => {
            // Only navigate if "to" exists AND it’s the main parent click
            if (props.item.to) {
                router.push(props.item.to).catch(() => {});
            }
        };

        return {
            handleGroupClick,
        };
    },
};
</script>
